import css from 'styled-jsx/css';

const styles = css.global`.store-proposal-sent .img-proposal {
  max-width: 288px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 24px;
}

.store-proposal-sent .text-title {
  font-family: SantanderHeadline;
  font-weight: 400;
  font-size: 32px;
  line-height: 42px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0 0 32px;
  color: #222;
}

.store-proposal-sent .text-description {
  font-family: SantanderMicroText;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin: 0;
  color: #222;
}

.store-proposal-sent .next-wrapper-bg {
  background: #f5f9fb;
  border-radius: 12px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 12px;
  margin: 32px 0;
}

.store-proposal-sent .text-next-container {
  margin-left: 20px;
}

.store-proposal-sent .text-next {
  font-family: 'SantanderHeadline';
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #222;
  margin-bottom: 32px;
}

.store-proposal-sent .text-next-item {
  font-family: SantanderMicroText;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin: 0;
  color: #222;
  margin-bottom: 16px;
}

.store-proposal-sent .text-next-item:last-of-type {
  margin-bottom: 0;
}

@media (min-width: 992px) {
  .store-proposal-sent {
    /* descontando o padding padrão */
    padding: calc(96px - 40px) 0;
  }

  .store-proposal-sent .ctn-home-24 {
    padding-left: 0;
    padding-right: 0;
  }

  .store-proposal-sent .content-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;
    position: relative;
    overflow: visible;
    gap: 4px;
    transform: translateX(-45px);
  }

  .store-proposal-sent .content-img {
    max-width: 395px;
    height: auto;
    flex: 1;
  }

  .store-proposal-sent .img-proposal {
    margin: 0;
    width: 100%;
    max-width: unset;
    transform: translateY(-77px);
  }

  .store-proposal-sent .text-title {
    color: #cc0000;
    font-size: 40px;
    line-height: 60px;
  }

  .store-proposal-sent .sn-button.red {
    max-width: 228px;
  }
}
`;

export default styles;